import * as React from 'react';
import {
	List,
	ListItemText,
	makeStyles,
	Badge,
	Typography,
	Dialog,
	DialogTitle,
	Button,
	DialogContentText,
	DialogActions,
	DialogContent,
} from '@material-ui/core';
import { Icon } from '@mitie/material-ui-extensions';
import {
	faCommentsAlt,
	faQuoteLeft,
	faCommentAltLines,
	faBallot,
	faWrench,
	faInboxOut,
} from '@fortawesome/pro-light-svg-icons';
import {
	faCommentsAlt as faCommentsAltSolid,
	faQuoteLeft as faQuoteLeftSolid,
	faBallot as faBallotSolid,
	faCommentAltLines as faCommentAltLinesSolid,
	faWrench as faWrenchSolid,
	faInboxOut as faInboxOutSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { stores } from '../../store';
import { IHeaderNavProps, ISiteObject } from '../../types';
import { observer } from 'mobx-react-lite';
import sidebarUseStyles from '../../assets/css/SideBarCss';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
	askBadge: {
		'& span': {
			backgroundColor: theme.palette.warning.main,
			width: '15px',
			height: '15px',
			minWidth: '15px',
			padding: '0 3px',
			fontSize: '0.7rem',
			left: '6px',
			top: '-6px',
		},
	},
	alignStyle: {
		padding: '16px 0px !important',
	},
	listChildItemSelected: {
		backgroundColor: '#bdbdbd',
	},
	PermissionsView: {
		display: 'none',
	},
}));

const HeaderNav = observer((props: IHeaderNavProps) => {
	const routes = React.useContext(stores.context.routes);
	const user = React.useContext(stores.context.user);
	const { routeName } = routes;
	const classesnew = useStyles();
	const classesSideBar = sidebarUseStyles();
	const sites: any = React.useContext(stores.context.site);
	const [selectedItem, setSelectedItem] = React.useState('');
	const appStores = React.useContext(stores.context.appStores);
	const [esmeConfig, setEsmeConfig] = React.useState(false);
	const [currentAskItems, setCurrentAskItems] = React.useState('0');
	const [open, setOpen] = React.useState(
		routeName === 'ask' ||
			routeName === 'chatbot' ||
			routeName === 'jobRequestForm' ||
			routeName === 'dynamicform' ||
			routeName === 'viewMyJobs' ||
			routeName === 'sentItems' ||
			routeName === 'feedback',
	);

	React.useEffect(() => {
		setCurrentAskItems(user.SRsCount);
	}, [user.SRsCount, selectedItem]);
	const navigateToPage = (route: string) => {
		routes.navigate(
			{ name: route },
			{
				clearParams: true,
			},
		);
	};

	React.useEffect(() => {
		let sitedatanew: any = localStorage.getItem('sitedatalat');
		let df: ISiteObject[] = sitedatanew ? JSON.parse(sitedatanew) : sites.siteList;
		const currentSiteIndex = df.findIndex((m: any) => m.Id == user.currentSiteId);
		if (user.currentSiteId != '' && df[currentSiteIndex]) {
			if (df[currentSiteIndex].EsmeClientId == null || df[currentSiteIndex].EsmeClientId == '') {
				setEsmeConfig(false);
			} else {
				setEsmeConfig(true);
			}
		}
	}, [esmeConfig, sites.siteList, user.currentSiteId]);
	const [rotName, setRoutName] = React.useState('');
	const classes = props.classNames;

	const [esmeDialogOpen, setEsmeDialogOpen] = React.useState(false);

	const dialogfn = (val: any) => {
		setRoutName(val);
		if (routes.testval === true && window.location.pathname === '/ask/chatbot') {
			setEsmeDialogOpen(true);
		} else if (routes.viewmyjobval === true && window.location.pathname === '/ask/view-my-jobs') {
			setEsmeDialogOpen(true);
		} else if (val === selectedItem) {
			navigateToPage('ask');
		} else {
			routes.navigate(
				{ name: val },
				{
					clearParams: true,
				},
			);
		}
	};

	const handleClickClose = () => {
		setEsmeDialogOpen(false);
	};

	const handleCloseChat = () => {
		// inform Esme before navigation
		resetChatbot();
		// delay 0.5 second so Esme if in Live chat can inform Mitel agent about user leaving chat
		setTimeout(() => {
			routes.testval = false;
			routes.viewmyjobval = false;
			setEsmeDialogOpen(false);

			routes.navigate(
				{ name: rotName },
				{
					clearParams: true,
				},
			);
		}, 500);
	};

	const resetChatbot = () => {
		const iframeEl: any = document.getElementById('myframe');
		iframeEl.contentWindow.postMessage('reset', '*');
	};

	return (
		<>
			<List
				component={'ul'}
				disablePadding={false}
				className={
					user.modulePermissions && user.modulePermissions.ASK
						? props.drawerOpen
							? classes.sideBarList
							: classes.miniSideBarList
						: classesnew.PermissionsView
				}
			>
				<li
					title={!props.drawerOpen ? 'Ask' : ''}
					onClick={() => {
						dialogfn('ask');
						appStores.drawerOpen = false;
						setOpen(true);
					}}
					aria-expanded={open}
					aria-controls="ask-collapse"
				>
					<a
						aria-label={routeName === 'ask' ? 'Ask Current' : 'Ask'}
						href="javascript:void(0)"
						className={clsx(
							'ancharTag',
							{
								subMenuMiniSideBar: !props.drawerOpen,
							},
							routeName === 'ask' ||
								routeName === 'chatbot' ||
								routeName === 'jobRequestForm' ||
								routeName === 'dynamicform' ||
								routeName === 'viewMyJobs' ||
								routeName === 'sentItems' ||
								routeName === 'feedback'
								? 'selected'
								: 'main-menu',
						)}
					>
						<span className={classes.listIcon}>
							<Icon
								icon={
									routeName === 'ask' ||
									routeName === 'chatbot' ||
									routeName === 'jobRequestForm' ||
									routeName === 'dynamicform' ||
									routeName === 'viewMyJobs' ||
									routeName === 'sentItems' ||
									routeName === 'feedback'
										? faCommentsAltSolid
										: faCommentsAlt
								}
							/>
						</span>
						{props.drawerOpen && <ListItemText primary="Ask" />}
					</a>
				</li>
				<li>
					{open && (
						<List
							id="ask-collapse"
							aria-live="polite"
							component={'ul'}
							disablePadding={false}
							className={props.drawerOpen ? classesSideBar.contentMenuFeed : classesSideBar.miniContentMenuFeed}
						>
							{esmeConfig && user.featurePermissions && user.featurePermissions.JOB_REQUEST_CHAT ? (
								<li
									title={!props.drawerOpen ? 'Job Request Chat' : ''}
									onClick={() => {
										if (selectedItem === 'chatbot') {
											setSelectedItem('');
										} else {
											setSelectedItem('chatbot');
										}
										dialogfn('chatbot');
										appStores.drawerOpen = false;
									}}
								>
									<a
										aria-label={routeName === 'chatbot' ? 'Job Request Chat Current' : 'Job Request Chat'}
										href="javascript:void(0)"
										className={clsx(
											'ancharTag',
											{
												subMenuMiniSideBar: !props.drawerOpen,
											},
											routeName === 'chatbot' ? 'selected sub-menu-selected' : 'sub-menu',
										)}
									>
										<span className={classes.listIcon}>
											<Icon icon={routeName === 'chatbot' ? faCommentAltLinesSolid : faCommentAltLines} />
										</span>
										{props.drawerOpen && <ListItemText primary="Job Request Chat" />}
									</a>
								</li>
							) : (
								''
							)}

							{user.CafmId === -1 && user.featurePermissions && user.featurePermissions.JOB_REQUEST_FORM ? (
								<li
									title={!props.drawerOpen ? 'Job Request Form' : ''}
									onClick={() => {
										if (selectedItem === 'jobRequestForm') {
											setSelectedItem('');
										} else {
											setSelectedItem('jobRequestForm');
										}
										dialogfn('jobRequestForm');
										appStores.drawerOpen = false;
									}}
								>
									<a
										aria-label={routeName === 'jobRequestForm' ? 'Job Request Form Current' : 'Job Request Form'}
										href="javascript:void(0)"
										className={clsx(
											'ancharTag',
											{
												subMenuMiniSideBar: !props.drawerOpen,
											},
											routeName === 'jobRequestForm' ? 'selected sub-menu-selected' : 'sub-menu',
										)}
									>
										<span className={classes.listIcon}>
											<Icon icon={routeName === 'jobRequestForm' ? faBallotSolid : faBallot} />
										</span>
										{props.drawerOpen && <ListItemText primary="Job Request Form" />}
									</a>
								</li>
							) : (
								''
							)}
							{user.featurePermissions && user.featurePermissions.JOB_REQUEST_FORM ? (
								<li
									title={!props.drawerOpen ? 'Job Request Form' : ''}
									onClick={() => {
										dialogfn('dynamicform');
										if (selectedItem === 'dynamicform') {
											setSelectedItem('');
										} else {
											setSelectedItem('dynamicform');
										}

										appStores.drawerOpen = false;
									}}
								>
									<a
										aria-label={routeName === 'dynamicform' ? 'Job Request Form Current' : 'Job Request Form'}
										href="javascript:void(0)"
										className={clsx(
											'ancharTag',
											{
												subMenuMiniSideBar: !props.drawerOpen,
											},
											routeName === 'dynamicform' ? 'selected sub-menu-selected' : 'sub-menu',
										)}
									>
										<span className={classes.listIcon}>
											<Icon icon={routeName === 'dynamicform' ? faBallotSolid : faBallot} />
										</span>
										{props.drawerOpen && <ListItemText primary="Job Request Form" />}
									</a>
								</li>
							) : (
								''
							)}
							{user.featurePermissions && user.featurePermissions.ARIA_FEEDBACK ? (
								<li
									title={!props.drawerOpen ? 'Aria Feedback' : ''}
									onClick={() => {
										if (selectedItem === 'feedback') {
											setSelectedItem('');
										} else {
											setSelectedItem('feedback');
										}

										dialogfn('feedback');
										appStores.drawerOpen = false;
										setTimeout(() => {
											document.getElementById('Feedback')?.focus();
										}, 50);
										appStores.drawerOpen = false;
										setTimeout(() => {
											document.getElementById('Feedback')?.focus();
										}, 50);
									}}
								>
									<a
										aria-label={routeName === 'feedback' ? 'Aria Feedback Current' : 'Aria Feedback'}
										href="javascript:void(0)"
										className={clsx(
											'ancharTag',
											{
												subMenuMiniSideBar: !props.drawerOpen,
											},
											routeName === 'feedback' ? 'selected sub-menu-selected' : 'sub-menu',
										)}
									>
										<span className={classes.listIcon}>
											<Icon icon={routeName === 'feedback' ? faQuoteLeftSolid : faQuoteLeft} />
										</span>
										{props.drawerOpen && <ListItemText primary="Aria Feedback" />}
									</a>
								</li>
							) : (
								''
							)}
							{esmeConfig && user.featurePermissions && user.featurePermissions.VIEW_MY_JOBS ? (
								<li
									title={!props.drawerOpen ? 'View My Jobs' : ''}
									onClick={() => {
										dialogfn('viewMyJobs');
										if (selectedItem === 'viewMyJobs') {
											setSelectedItem('');
										} else {
											setSelectedItem('viewMyJobs');
										}
										appStores.drawerOpen = false;
									}}
								>
									<a
										aria-label={routeName === 'viewMyJobs' ? 'View My Jobs Current' : 'View My Jobs'}
										href="javascript:void(0)"
										className={clsx(
											'ancharTag',
											{
												subMenuMiniSideBar: !props.drawerOpen,
											},
											routeName === 'viewMyJobs' ? 'selected sub-menu-selected' : 'sub-menu',
										)}
									>
										<span className={classes.listIcon}>
											<Icon icon={routeName === 'viewMyJobs' ? faWrenchSolid : faWrench} />
										</span>
										{props.drawerOpen && <ListItemText primary="View My Jobs" />}
									</a>
								</li>
							) : (
								''
							)}
							{user.featurePermissions && user.featurePermissions.SENT_ITEMS ? (
								<li
									title={!props.drawerOpen ? 'Sent Items' : ''}
									onClick={() => {
										dialogfn('sentItems');
										if (selectedItem === 'sentItems') {
											setSelectedItem('');
										} else {
											setSelectedItem('sentItems');
										}
										appStores.drawerOpen = false;
										setTimeout(() => {
											document.getElementById('SentItems')?.focus();
										}, 50);
										appStores.drawerOpen = false;
										setTimeout(() => {
											document.getElementById('SentItems')?.focus();
										}, 50);
									}}
								>
									<a
										aria-label={routeName === 'sentItems' ? 'Sent Items Current' : 'Sent Items'}
										href="javascript:void(0)"
										className={clsx(
											'ancharTag',
											{
												subMenuMiniSideBar: !props.drawerOpen,
											},
											routeName === 'sentItems' ? 'selected sub-menu-selected' : 'sub-menu',
										)}
									>
										<span className={classes.listIcon}>
											<React.Fragment>
												{currentAskItems !== '0' ? (
													<Badge
														badgeContent={currentAskItems || '0'}
														color="primary"
														className={classesnew.askBadge}
														anchorOrigin={{
															vertical: 'top',
															horizontal: 'right',
														}}
													>
														<Typography />
													</Badge>
												) : (
													''
												)}
												<Icon icon={routeName === 'sentItems' ? faInboxOutSolid : faInboxOut} />
											</React.Fragment>
										</span>
										{props.drawerOpen && <ListItemText primary="Sent Items" />}
									</a>
								</li>
							) : (
								''
							)}
						</List>
					)}
				</li>
			</List>
			<Dialog style={{ margin: 'auto', maxWidth: '375px' }} open={esmeDialogOpen} onClose={handleClickClose}>
				<DialogContent>
					<DialogTitle id="form-dialog-title" className={classesnew.alignStyle}>
						Are you sure you want to leave the chat
					</DialogTitle>
					<DialogContentText>
						Please take a note of the Service Request reference if given, this chat will end and be deleted.
					</DialogContentText>
					<DialogActions>
						<Button title="Close chat" onClick={handleCloseChat} color="primary">
							Close chat
						</Button>
						<Button title="Return to chat" onClick={handleClickClose} color="primary">
							Return to chat
						</Button>
					</DialogActions>
				</DialogContent>
			</Dialog>
		</>
	);
});

export default HeaderNav;
